import { Box, Input, Link } from '@chakra-ui/react';
import { saveTest } from './utils';
import { transformRSInput } from '../../formControllers/Transformation/Utils';
import React from 'react';
import { onLink } from '../../handlers';
import { getUsefulVars } from '../../handlers/helpers';


const TestLink = ({ props,qObj,testName,value,placeholder }) => {
  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const index = props.stateProps.sectionData.sectionIndex;
  const uv = getUsefulVars(props);
  const buttonLabel = value === '' ? 'Take Quiz' : 'Done';
  const buttonClass = value === '' ? 'aptitudeTestLink' : 'aptitudeTestLinkRetake';
  return(
  <Box className="testLinkRow" display='flex' justifyContent='space-between'  paddingLeft="8px" marginLeft="1.8rem" marginTop=".6rem" paddingTop='.5rem' width='90%'>
    <Box className="testLinkLeft" fontWeight='bold' width='50%'>{qObj.question}</Box>
    <Box className="testLinkRight" display='flex' justifyContent='space-between' width='29%'>
      <Box paddingTop='.5rem' marginRight='1rem'><Link className={buttonClass} isExternal={true}
                                  onClick={() => onLink(false, uv.formikProps, uv.stateProps, testName, 0, 'section', uv.resumeIndex, props)}
    >{buttonLabel}</Link></Box>
    <Box width='40%'>
      <Input
        id={qObj.qid}
        onBlur={e=> {
          saveTest(e,props);
        }}
        placeholder={qObj.placeholder}
        value = {value}
        width = '100%'
        onChange={e =>
          transformRSInput(e, jobSeekerData, index, qObj, props)
        }
        sx={{ paddingRight: 0, margin: 0 }}
      /></Box>

  </Box>
  </Box>
  )
};

export default TestLink;